var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key:
        "message-counter-" +
        _vm.deliverable.id +
        "-" +
        _vm.deliverable.unread_message_count,
      class: _vm.getClasses,
      on: { click: _vm.clickMessageCounter }
    },
    [
      _vm.deliverable.unread_message_count == 0 &&
      _vm.deliverable.total_message_count > 0 &&
      !_vm.deliverable.is_master
        ? _c("img", {
            staticClass: "chat-bubbles-read",
            attrs: { src: require("@/csmworkflow/img/chat-bubbles-read.svg") }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deliverable.unread_message_count == 0 &&
      _vm.deliverable.total_message_count > 0 &&
      _vm.deliverable.is_master
        ? _c("img", {
            staticClass: "chat-bubbles-master-read",
            attrs: {
              src: require("@/csmworkflow/img/chat-bubbles-master-read.svg")
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deliverable.unread_message_count > 0 && _vm.deliverable.is_master
        ? _c("img", {
            staticClass: "chat-bubbles-master-unread",
            attrs: {
              src: require("@/csmworkflow/img/chat-bubbles-master-unread.svg")
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deliverable.unread_message_count > 0 && !_vm.deliverable.is_master
        ? _c("img", {
            staticClass: "chat-bubbles-unread",
            attrs: { src: require("@/csmworkflow/img/chat-bubbles-unread.svg") }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deliverable.total_message_count == 0
        ? _c("img", {
            staticClass: "chat-bubbles-none",
            attrs: { src: require("@/csmworkflow/img/chat-bubbles-none.svg") }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deliverable.unread_message_count > 0
        ? _c("span", {
            staticClass: "message-count",
            domProps: {
              innerHTML: _vm._s(_vm.deliverable.unread_message_count)
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }